export default {
  title: 'Comenzar',
  description: 'Para cargar esta página, debe completar la guía de inicio',
  button: 'Comenzar',
};
